import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".services-section");
  if (!section) return;

  const heading = section.querySelector(".services-header h2");
  const services = section.querySelectorAll(".service-item");

  // Fade-in + rise animation for main heading
  gsap.fromTo(
    heading,
    { opacity: 0, y: 50, filter: "blur(6px)" },
    {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    }
  );

  // Fade-up stagger animation for each service item
  gsap.fromTo(
    services,
    { opacity: 0, y: 50, filter: "blur(6px)" },
    {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1,
      stagger: 0.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: section,
        start: "top 75%",
        toggleActions: "play none none none",
      },
    }
  );
});

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".services-section .service-header")
    .forEach((header) => {
      header.addEventListener("click", () => {
        const parent = header.closest(".service-item");
        parent.classList.toggle("open");
      });
    });
});
